import { useReducer, useCallback } from 'react'

const actions = {
  find: (state, action) => ({
    ...state,
    differences: state.differences.map(difference => {
      if (difference.id === action.id) {
        return { ...difference, userFound: true }
      } else {
        return difference
      }
    }),
    isWin: state.differences.filter(({ userFound }) => !userFound).length === 1,
  }),
  end: state => ({
    ...state,
    differences: state.differences.map(difference => {
      if (!difference.userFound) {
        return { ...difference, notFoundInTime: true }
      } else {
        return difference
      }
    }),
  }),
}

function reducer(state, action) {
  const handler = actions[action.type]
  if (!handler) {
    throw new Error('Unsupported action type')
  }
  return handler(state, action)
}

export function useDifferences({ initialDifferences = [] }) {
  const [state, dispatch] = useReducer(reducer, {
    differences: initialDifferences,
    isWin: false,
  })

  const findDifference = useCallback(id => {
    dispatch({ type: 'find', id })
  }, [])

  const endDifference = useCallback(() => {
    dispatch({ type: 'end' })
  }, [])

  return {
    state,
    findDifference,
    endDifference,
  }
}
